import { Record, String, Boolean, Number, Union, Literal } from "runtypes";
import type { Static } from "runtypes";

const BaseComponent = Record({
  handle: String,
});

export const OnOffComponent = BaseComponent.extend({
  type: Literal("on_off_component"),
  isOn: Boolean,
});

export const QuantityBasedComponent = BaseComponent.extend({
  type: Literal("quantity_based_component"),
  used: Number,
  allocated: Number,
});

export const PrepaidUsageComponent = BaseComponent.extend({
  type: Literal("prepaid_usage_component"),
  used: Number,
  allocated: Number,
});

export const FeatureUsage = Union(OnOffComponent, QuantityBasedComponent, PrepaidUsageComponent);

export type FeatureUsage = Static<typeof FeatureUsage>;

// Type guards
export const isQuantityBasedComponent = (feature: FeatureUsage): feature is Static<typeof QuantityBasedComponent> =>
  feature.type === "quantity_based_component";

export const isPrepaidUsageComponent = (feature: FeatureUsage): feature is Static<typeof PrepaidUsageComponent> =>
  feature.type === "prepaid_usage_component";

export const isOnOffComponent = (feature: FeatureUsage): feature is Static<typeof OnOffComponent> => feature.type === "on_off_component";

// Helper functions
export const getUsedQuantity = (feature: FeatureUsage): number => {
  if (isQuantityBasedComponent(feature) || isPrepaidUsageComponent(feature)) {
    return feature.used;
  }
  return 0;
};

export const getAllocatedQuantity = (feature: FeatureUsage): number => {
  if (isQuantityBasedComponent(feature) || isPrepaidUsageComponent(feature)) {
    return feature.allocated;
  }
  return 0;
};

export const getIsOn = (feature: FeatureUsage): boolean => {
  if (isOnOffComponent(feature)) {
    return feature.isOn;
  }
  return false;
};
